import { __read, __rest, __spread } from "tslib";
import { mergePropertiesGroup } from '../../utils';
import { KEEN_KEY, KEEN_VALUE } from '../../constants';
export var defaultTransformation = function (result, parserSettings) {
    var mergePropertiesOrder = parserSettings.mergePropertiesOrder;
    var data = [];
    var keys = new Set();
    result
        .map(function (groupedProperties) {
        return mergePropertiesGroup(groupedProperties, mergePropertiesOrder);
    })
        .forEach(function (_a) {
        var result = _a.result, properties = __rest(_a, ["result"]);
        Object.values(properties).forEach(function (property) {
            var _a;
            data.push((_a = {}, _a[KEEN_KEY] = property, _a[KEEN_VALUE] = result, _a));
        });
    });
    keys.add(KEEN_VALUE);
    return {
        data: data,
        keys: __spread(keys),
    };
};
